import { ExclamationIcon } from './ExclamationIcon';

/**
 * author: Austin Andrews
 * id 06E68A9B-2ED4-4697-82A2-02F1FA342D55
 * name exclamation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exclamation.svg
 * tags
 * - Math 
 */
export const FactorialIcon = ExclamationIcon;
export default FactorialIcon